<template>
  <div class="container-fluid">
    <div class="row px-0 px-md-2 my-4 back-txt">
      <div class="col-6">
        <router-link to="/">
          <span class="mr-1">&#8249;</span>Go back to movie list
        </router-link>
      </div>
    </div>

    <div class="col-12">
      <!-- Selected Seats Card -->
      <div class="row">
        <div
          class="
            col-md-6 col-lg-3
            p-3 p-xl-3
            cs-scr-ticket
            h-75
            mx-auto
            mb-5 mb-lg-0
          "
        >
          <!-- Movie Details -->
          <div class="d-flex">
            <div
              class="
                col-5 col-md-6 col-xl-5
                pr-xl-2 pr-lg-0 pr-1
                pl-0 pl-md-2
                rounded
              "
            >
              <img
                v-lazy="movieDetails.md_thumbnail_url"
                class="img-fluid"
                style="border-radius: 7px"
              />
            </div>
            <div class="d-flex flex-column justify-content-between pl-3">
              <div>
                <p class="mb-1">{{ movieDetails.movie_title }}</p>
                <ul class="list-inline movie-tickDetails">
                  <li class="list-inline-item">
                    {{ movieDetails.mrrdr_runtime }}
                  </li>
                  <li class="list-inline-item">
                    {{ movieDetails.mrrdr_release_date_year }}
                  </li>
                  <li class="list-inline-item">
                    {{ movieDetails.lang_name }} ({{ movieDetails.mf_name }})
                  </li>
                </ul>
              </div>

              <div>
                <p class="rt-txt2">
                  <span class="d-block small">Rating</span>
                  {{ movieDetails.rating }}
                </p>
              </div>
            </div>
          </div>
          <hr class="topLine my-2" />

          <!-- Cinema Details -->
          <div>
            <small class="vCont">Cinema:</small>
            <p class="hCont">
              {{ movieDetails.cine_name }}, {{ movieDetails.cine_address }}
            </p>
            <small class="vCont">Screen:</small>
            <p class="hCont">
              {{ movieDetails.screen_name }}
            </p>
          </div>

          <!-- Show Date and Time -->
          <div>
            <small class="vCont">Date &amp; Time:</small>
            <ul class="list-inline dateTime hCont">
              <li class="list-inline-item">
                <!-- {{ movieDetails.ss_start_date | date }} | -->
                {{showDateHandlaler(movieDetails.ss_start_date)}}
                {{ timeFormat(movieDetails.ss_start_show_time) }}
              </li>
            </ul>
          </div>

          <!-- SCREENING TYPE -->
          <div v-if="CategoryID == 2 || CategoryID == 3">
            <small class="vCont">Screening Type:</small>
            <p class="hCont">Crowdsourced Screening</p>
          </div>

          <!-- SELECTED SEATS -->
          <div class>
            <small class="vCont">Pick Seats:</small>
            <ul class="list-inline seatList hCont" v-if="getSeatsSelected">
              <li
                v-for="(singleSeat, singleSeatIndex) in getSeatsSelected"
                :key="singleSeatIndex"
                class="list-inline-item"
              >
                <span v-if="vista_schedule_id">
                  {{ `${singleSeat.rowLabel}${singleSeat.seatLabel}` }}
                </span>
                <span v-else-if="rts_performance_id">
                  {{ `${singleSeat.RowDes._text}${singleSeat.ColDes._text}` }}
                </span>
                <span v-else>
                  {{ singleSeat.sl_seat_name }}
                </span>
              </li>
            </ul>
          </div>
          <div
            :class="{ hide: this.$store.getters.SELECTED_SEATS.length === 0 }"
            class="amount-box my-4"
          >
            <div class="ticketAmount">
              <div class="d-flex justify-content-between">
                <p>
                  <span
                    >Tickets ({{
                      this.$store.getters.SELECTED_SEATS.length
                    }}</span
                  >) :
                </p>
                <p v-if="this.$store.getters.SELECTED_SEATS.length > 0">
                  {{ curr_code }} {{ currFormat(totalNetAmout) }}
                </p>
              </div>
              <div
                class=""
                v-if="chargeTypeArray && chargeTypeArray.length > 0"
              >
                <div
                  class="d-flex justify-content-between"
                  v-for="(charge, chargeIndex) in [...chargeTypeArray].reverse()"
                  :key="chargeIndex"
                >
                  <p>{{ charge.ct_name }} :</p>
                  <p>
                    {{ curr_code }}
                    {{ currFormat(charge.tax_amount) }}
                  </p>
                </div>
              </div>
              <!--Added by Yogesh@2019-09-10 | @Description => To show the service tax-->

              <hr class="bottomLine my-4" />
            </div>

            <div
              class="d-flex justify-content-between"
              :class="{ hide: this.$store.getters.SELECTED_SEATS.length === 0 }"
            >
              <div>
                <p class="mb-0 vCont">Total Amount Payable :</p>
                <small class="vCont"
                  >(Amount inclusive of all service fees and taxes)</small
                >
              </div>
              <p class="hCont">
                {{ curr_code }} {{ currFormat(totalAmountPrice) }}
              </p>
            </div>
          </div>
        </div>
        <!-- TICKET END -->

        <!-- TABS START -->
        <div class="col-md-12 col-lg-9 px-0 px-lg-3 modalCus">
          <div role="tablist">
            <b-card no-body class="seat-selection mb-1" id="scrollToSection">
              <b-card-header
                v-on:click="onClickTab()"
                header-tag="header"
                class="accordion-header"
                role="tab"
              >
                <div class="d-flex align-items-center header-box">
                  <b-button
                    block
                    href="#"
                    class="py-md-3"
                    variant="default"
                    :class="showCollapseSeatLayout ? 'active' : ''"
                  >
                    1. Select Seats
                    <span v-if="!showCollapseSeatLayout" class="check-markIcon">
                      <img
                        src="@/assets/img/svg/plus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                    <span v-if="showCollapseSeatLayout" class="check-markIcon">
                      <img
                        src="@/assets/img/svg/minus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                  </b-button>
                </div>
              </b-card-header>

              <b-collapse
                id="accordion4"
                v-model="showCollapseSeatLayout"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <div class="col-12 mx-auto text-center px-0">
                    <div class="text-center">
                      <img
                        src="@/assets/img/svg/screen.svg"
                        class="img-fluid d-none d-md-block mx-auto"
                      />
                      <img
                        src="@/assets/img/svg/screen-mobile-new.svg"
                        class="mob-img-fluid d-md-none"
                      />
                    </div>

                    <div class="seat-count mt-0 mb-4 my-md-4">
                      <p
                        v-if="totalNumberOfSeats == 0"
                        class="text-center mt-3"
                      >
                        HOW MANY SEATS?
                      </p>
                      <p
                        v-if="
                          totalNumberOfSeats !== 0 && totalNumberOfSeats == 1
                        "
                        class="text-center mt-3"
                      >
                        Selected :
                        <span
                          >{{ this.$store.getters.SELECTED_SEATS.length }} /
                          {{ totalNumberOfSeats }} Seat</span
                        >&nbsp;&nbsp;
                        <span class="edit-class" v-on:click="onEdit()"
                          >(Edit)</span
                        >
                      </p>
                      <p
                        v-if="
                          totalNumberOfSeats !== 0 && totalNumberOfSeats != 1
                        "
                        class="text-center mt-3"
                      >
                        Selected :
                        <span
                          >{{ this.$store.getters.SELECTED_SEATS.length }} /
                          {{ totalNumberOfSeats }} Seats</span
                        >&nbsp;&nbsp;
                        <span class="edit-class" v-on:click="onEdit()"
                          >(Edit)</span
                        >
                      </p>
                      <ul class="list-inline pick-seats mt-4">
                        <li
                          v-if="totalNumberOfSeats == 0"
                          v-for="(number, a) in 8"
                          :key="a"
                          class="list-inline-item"
                          v-on:click="editNumberOfSeats(number)"
                          :class="{ active: number == totalNumberOfSeats }"
                        >
                          {{ number }}
                        </li>
                      </ul>
                    </div>

                    <div class="seat-layout table-responsive">
                      <div
                        class="mx-auto text-center"
                        v-if="totalNumberOfSeats > 0 && seatType.length > 0"
                        v-for="(singleSeatLayout, seatIndex) in seatType"
                        :key="seatIndex"
                      >
                        <div
                          class="mt-4 mb-2 seat-formatTxt"
                          v-if="singleSeatLayout.seatsFinal.length > 0"
                        >
                          <div
                            class="seat-catg screen-class"
                            style="margin-top: 10px"
                          >
                            <div>({{ singleSeatLayout.seatType }})</div>
                            <div>
                              Ticket Price : {{ curr_code }}
                              {{
                                currFormat(singleSeatLayout.seat_net_price) ||
                                currFormat(singleSeatLayout.seat_price)
                              }}
                            </div>
                          </div>
                        </div>
                        <table class="mx-auto seat-table">
                          <tr
                            v-for="(
                              seatArray, seatRowIndex
                            ) in singleSeatLayout.seatsFinal"
                            :key="seatRowIndex"
                          >
                            <td
                              v-for="(singleSeat, singleSeatIndex) in seatArray"
                              :key="singleSeatIndex"
                            >
                              <div
                                v-if="singleSeat.srt_id == 2"
                                class="hide py-2"
                              ></div>
                              <div v-else>
                                <div
                                  v-if="vista_schedule_id"
                                  v-on:click="
                                    ($event) => {
                                      handlerSeatSelected(
                                        singleSeat,
                                        seatRowIndex,
                                        singleSeatIndex,
                                        null,
                                        null,
                                        $event,
                                        seatIndex
                                      );
                                      seatsSelectedRateGroup();
                                    }
                                  "
                                  :class="getVistaSeatClass(singleSeat)"
                                ></div>
                                <div
                                  v-else-if="rts_performance_id"
                                  v-on:click="
                                    ($event) => {
                                      handlerSeatSelected(
                                        singleSeat,
                                        seatRowIndex,
                                        singleSeatIndex,
                                        null,
                                        null,
                                        $event,
                                        seatIndex
                                      );
                                      seatsSelectedRateGroup();
                                    }
                                  "
                                  :class="getRtsSeatClass(singleSeat)"
                                ></div>
                                <div
                                  v-else
                                  v-on:click="
                                    ($event) => {
                                      handlerSeatSelected(
                                        singleSeat,
                                        seatRowIndex,
                                        singleSeatIndex,
                                        null,
                                        null,
                                        $event,
                                        seatIndex
                                      );
                                      seatsSelectedRateGroup();
                                    }
                                  "
                                  :class="
                                    singleSeat.selectStatus == true
                                      ? singleSeat.srt_id == 3
                                        ? 'wheel active'
                                        : 'seat active'
                                      : singleSeat.seat_reserve_type_id == 1
                                      ? 'seat'
                                      : singleSeat.seat_reserve_type_id == 3
                                      ? 'wheel'
                                      : singleSeat.seat_reserve_type_id == 6
                                      ? 'seat'
                                      : singleSeat.seat_reserve_type_id == 7
                                      ? 'seat'
                                      : singleSeat.seat_reserve_type_id == 8
                                      ? singleSeat.srt_id == 3
                                        ? 'wheel disabled seat'
                                        : 'seat disabled'
                                      : singleSeat.seat_reserve_type_id == 9
                                      ? 'seat disabled'
                                      : singleSeat.seat_reserve_type_id == 10
                                      ? 'seat'
                                      : singleSeat.seat_reserve_type_id == 11
                                      ? 'seat'
                                      : singleSeat.seat_reserve_type_id == 12
                                      ? 'seat disabled'
                                      : singleSeat.seat_reserve_type_id == 13
                                      ? 'seat disabled'
                                      : 'seat'
                                  "
                                ></div>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                    <ul class="list-inline seat-info my-4 my-md-5">
                      <li class="list-inline-item">
                        <img
                          src="@/assets/img/svg/empty-seat.svg"
                          class="pb-1 mr-2"
                        />Available
                      </li>
                      <li class="list-inline-item">
                        <img
                          src="@/assets/img/svg/disable-seat.svg"
                          class="pb-1 mr-2"
                        />Unavailable
                      </li>
                      <li class="list-inline-item">
                        <img
                          src="@/assets/img/WhAv1.png"
                          style="width: 17px"
                          class="pb-1 mr-2"
                        />Wheelchair
                      </li>
                    </ul>

                    <div class="text-danger my-2"></div>

                    <!-- <router-link to v-on:click.native="setBookingSeats()"> -->
                    <div to @click="setBookingSeats()">
                      <div
                        v-if="
                          this.$store.getters.SELECTED_SEATS.length > 0 &&
                          this.$store.getters.SELECTED_SEATS.length ==
                            totalNumberOfSeats
                        "
                        class="proceed-btn"
                      >
                        <button
                          type="button"
                          name
                          id
                          class="btn btn-danger py-md-2 px-md-4 my-3"
                        >
                          Confirm
                        </button>
                      </div>
                      <!-- </router-link> -->
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>

          <div class="verify-c">
            <b-modal
              hide-footer
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              ref="WheelChairModal"
              class="text-center"
              id="WheelChairModal"
              title="Wheel Chair"
            >
              <div class="p-5">
                <div class="text-center mb-3">
                  <img
                    width="47"
                    height="auto"
                    src="@/assets/img/WheelSel.png"
                  />
                </div>
                <div class="text-center mt-3 mt-md-0 font-weight-bold">
                  Notice
                </div>
                <div class="text-center mt-3 mt-md-0">
                  You have selected a wheelchair space which is for wheelchair
                  user only.
                </div>
                <b-button
                  v-on:click="onClickOk()"
                  class="
                    w-50
                    mx-auto
                    gogo-btn
                    btn btn-danger
                    mt-3
                    d-flex
                    justify-content-center
                    align-items-center
                  "
                  >OK
                </b-button>
              </div>
            </b-modal>
          </div>

          <b-modal
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            hide-footer
            ref="SeatRealeased"
            class="text-center"
            id="minimumPayment"
            title="FAILED !"
          >
            <div class="p-5">
              <div class="text-center mt-3 mt-md-0">{{ showMessage }}</div>
              <b-button
                v-on:click="hideModal"
                class="
                  w-50
                  mx-auto
                  gogo-btn
                  btn btn-danger
                  mt-3
                  d-flex
                  justify-content-center
                  align-items-center
                "
                >Go Back</b-button
              >
            </div>
          </b-modal>
        </div>
      </div>
    </div>

    <!-- RateCard Modal -->
    <b-modal
      hide-footer
      hide-header
      id="showRateCard"
      ref="showRateCard"
      title="Show Rate Card"
      class=""
      size="lg"
    >
      <div class="container px-2 px-md-3">
        <div class="select-seat-container-myticket">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto">
            <div class="row">
              <div class="col-12 py-3 bg-light rounded">
                <div class="row">
                  <div class="col-4">
                    <strong>TICKET </strong>
                  </div>
                  <div class="col-3">
                    <strong> PRICE </strong>
                  </div>
                  <div class="col-5">
                    <strong>No of Seats </strong>
                  </div>
                </div>
              </div>

              <div
                v-for="(item, index) in seatsSelectedRateGroupNew"
                :key="index"
                class="col-12 py-2 border-bottom"
                v-if="seatsSelectedRateGroupNew"
              >
                <div class="st-name">{{ item.srt_name }}</div>
                <div class="row align-self-center">
                  <div
                    v-for="(rg, rg_index) in item.rate_card_group"
                    class="col-12 row my-2 p-0"
                  >
                    <div
                      class="col-4 align-self-center"
                      style="line-break: anywhere"
                    >
                      <strong>
                        {{ rg.tt_name }}
                      </strong>
                    </div>
                    <div class="col-3 align-self-center">
                      <strong>
                        {{ curr_code }} {{ currFormat(rg.rc_total_amount) }}
                      </strong>
                    </div>
                    <div class="col-5">
                      <div
                        class="
                          d-flex
                          align-items-center
                          justify-content-center
                          w-100
                          h-100
                        "
                      >
                        <button
                          @click="totalCount(rg, index, rg_index, 'decrement')"
                          class="cursor-pointer btn-subtract-myticket"
                          :class="rg.totalSeatSelected == 0 ? 'disabled' : ''"
                        >
                          -
                        </button>
                        <strong class="w-100px">{{
                          rg.totalSeatSelected
                        }}</strong>
                        <button
                          @click="totalCount(rg, index, rg_index, 'increment')"
                          class="cursor-pointer btn-add-myticket"
                          :class="
                            item.totalSelected == item.AllSeats.length
                              ? 'disabled'
                              : ''
                          "
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 py-3 bg-light rounded">
                    <div class="row">
                      <div class="col-4">
                        <strong>Total Seat Selected</strong>
                      </div>
                      <div class="col-4">
                        <strong> </strong>
                      </div>
                      <div class="col-4">
                        <strong
                          >{{ item.totalSelected }}/{{
                            item.AllSeats.length
                          }}</strong
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-12 py-3 my-2 bg-light rounded">
                    <div class="row">
                      <div class="col-4">
                        <strong>Total Amoun1t</strong>
                      </div>
                      <div class="col-4">
                        <strong> </strong>
                      </div>
                      <div class="col-4">
                        <strong
                          >{{ curr_code }}
                          {{ currFormat(totalAmountPrice) }}</strong
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-12 py-4">
                    <button
                      :disabled="errorMessage ? true : false"
                      class="btn btn-danger py-2 px-5 mt-3"
                      @click="onSubmitFromRateCardModal"
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import vistaServices from "@/services/vistaServices.js";
import { makeRequest } from "@/helper/internet.js";
import cloneDeep from "lodash/cloneDeep";
import Slick from "vue-slick";
import $ from "jquery";
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";
import _ from "lodash";
import MainServices from "@/services/mainService.js";
import moment from "moment";
import rtsServices from "@/services/rtsServices";
var VueScrollTo = require("vue-scrollto");

// import { dragscroll } from 'vue-dragscroll'

export default {
  name: "MyComponent",
  directives: {
    // 'dragscroll': dragscroll
  },

  computed: {
    chargeTypeArray() {
      let selectedSeats = this.$store.getters.SELECTED_SEATS;
      let tempArr = [];
      let testObj = {};
      let finalArr = [];

      if (selectedSeats.length > 0) {
        selectedSeats.forEach((x) => {
          if (x.hasOwnProperty("chargeTypeArray")) {
            x.chargeTypeArray.forEach((y) => {
              tempArr.push(y);
            });
          }
        });
      }

      if (tempArr.length > 0) {
        tempArr.forEach(function (o) {
          if (!testObj[o.ct_id]) {
            testObj[o.ct_id] = {
              ct_id: o.ct_id,
              ct_name: o.ct_name,
              tax_amount: 0,
              quantity: o.quantity,
            };
            finalArr.push(testObj[o.ct_id]);
          }
          testObj[o.ct_id].tax_amount += +o.tax_amount;
        });
      }
      // console.log(
      //   "this.$store.getters.SELECTED_SEATS",
      //   this.$store.getters.SELECTED_SEATS
      // );
      // // console.log("finalArr", finalArr);
      return finalArr;
    },
    curr_code() {
      return this.$store.getters.getCurrCode;
    },
    ...mapGetters([
      "getSeatLayout",
      "getNowShowingDates",
      "getMovieDetailsScheduleList",
      "seatType",
      "seatsSelected",
      "totalPrice",
      "totalGrossPrice",
      // "getselectedDate",
      "getMovieDetailsScheduleList",
      "getMovieDetailsObject",
      "schedule_details_obj",
      "getGlobalCurrency",
      "getMovieDates",
      "getMovieId",
      "getCurrentLangIsoCode",
      "totalNumberOfSeats",
    ]),
    getSeatsSelected() {
      return this.$store.getters.SELECTED_SEATS.length > 0
        ? this.$store.getters.SELECTED_SEATS
        : [];
    },
    ShowProceed() {
      let count = 0;
      this.priceTypeArray.map((x) => {
        x.PriceType.map((y) => {
          count = count + y.Selected;
        });
      });
      if (this.selectedSeats.length == count) {
        this.remainingTicket = 0;
        return true;
      } else {
        this.remainingTicket = this.selectedSeats.length - count;
        return false;
      }
    },
  },

  components: {
    Slick,
    DatePick,
  },
  filters: {
    moment(date) {
      return moment(date).format("MMM DD, YYYY | h:mm A");
    },
    date(date) {
      return moment(date).format("MMM DD, YYYY");
    },
  },

  data() {
    return {
      ticketPriceNew: 0,
      priceTypeArray: [],
      promoApplied: false,
      remainingTicket: 0,
      sSlider: {
        dots: false,
        arrows: false,
        slidesToShow: 3.5,
        slidesToScroll: 3,
        centerPadding: "50px",
        promoApplied: false,
        DiscountValue: "",

        loop: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              dots: false,
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              dots: false,
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      },
      count: 0,
      showCollapse: false,
      showMessage: "",
      showCollapseSeatLayout: true,
      date: "2019-01-01",
      movieDetails: {},
      MovieID: "",
      CategoryID: "",
      CinemaScheduleID: "",
      CinemaList: [],
      selectedCinemaObject: {},
      ShowDates: [],
      ShowTimes: {},
      Currency: "",
      ShowTypes: {},
      CinemaTimeScheduleID: "",
      selectedTime: "",
      ScreeningType: "",
      seatLayout: [],
      seatTypes: [],
      showDetails: {
        CinemaName: "Citimall",
        CinemaAddress: "Adsd",
        ShowDateTime: "2019-20-20",
      },
      numberOfSeatsSelected: 0,
      totalNumberOfSeats: 0,
      selectedSeats: [],
      row: "",
      column: "",
      newSeatLayout: [],
      totalAmount: "",
      OGtotalAmount: "",
      promocode: "",
      promocodeSuccesMessage: "",
      promocodeErrorMessage: "",
      ServiceFee: 0,
      TotalPriceNew: 0,
      showModalPrice: false,
      TaxRate: 0,
      TaxAmount: 0,
      ServiceFeePer: 0,
      ServiceFeeNew: 0,
      TaxAmountNew: 0,
      //
      ss_id: 0,
      screen_id: 0,
      vista_schedule_id: null,
      rts_performance_id: null,
      seatsSelectedRateGroupNew: [],
      totalAmountPrice: 0,
      totalSeatBooked: 0,
      totalNetAmout: 0,
      checkPopupExist: false,
      errorMessage: "",
    };
  },
  beforeMount() {
    this.onResetSeatLayout();

    this.MovieID = this.$route.params.md_id;
    this.CategoryID = 1;
    this.ss_id = this.$route.params.ss_id;
    this.screen_id = this.$route.params.screen_id;

    if (this.$route.query.vista_schedule_id)
      this.vista_schedule_id = this.$route.query.vista_schedule_id;
    if (this.$route.query.rts_performance_id)
      this.rts_performance_id = this.$route.query.rts_performance_id;

    if (this.CategoryID == 2 || this.CategoryID == "2") {
      this.secureStore.set("SCRTN", "Crowdsourced Screening");
    }
    this.fetchScheduleDetail();
    // this.fetchCinemasList();

    this.getSeats({
      md_id: this.MovieID,
      screen_id: this.screen_id,
      ss_id: this.ss_id,
      vista_schedule_id: this.vista_schedule_id,
      rts_performance_id: this.rts_performance_id,
    });
  },
  mounted() {
    this.showLoading();
    setTimeout((x) => {
      this.hideLoading();
    }, 2000);
  },
  methods: {
    ...mapActions([
      "getSeats",
      "getMovieDetailsSelectedFilter",
      "SelectNumberOfSeats",
      "seatHandler",
      "RESERVE_SEATS",
      "onResetSeatLayout",
      "getAdditionalCharges",
      // "getselectedDate",
      "onSetDefaultFilter",
      "getScheduleDetails",
      "setScheduleObj",
      "onGetAllMoviesSchedulesSeatPage",
      "onSetCompleteRateCard",
      "onSetCompleteNewTotalAmount",
      "getVouchersList",
      "fetchStripePublisherKey",
      "getAllShowDates",
      "onGetMovieShowDates",
      "onGetMovieDetails",
    ]),

 showDateHandlaler(date) {
     return moment(date).format("MMMM DD, YYYY")
    },

    getVistaSeatClass(singleSeat) {
      if (singleSeat.selectStatus) {
        if (singleSeat.status === 3) {
          return "wheel active";
        } else {
          return "seat active";
        }
      } else {
        if ([1, 2, 5].includes(singleSeat.status)) {
          if (singleSeat.originalStatus === 3) {
            return "wheel disabled seat";
          } else {
            return "seat disabled";
          }
        } else {
          if (singleSeat.status === 3) {
            return "wheel";
          } else {
            return "seat";
          }
        }
      }
    },
    getRtsSeatClass(singleSeat) {
      if (singleSeat.selectStatus) {
        if (singleSeat.Type._text === "1") {
          return "wheel active";
        }
        return "seat active";
      } else {
        if ([1, 2, 3, 5, 6].includes(singleSeat.Status._text)) {
          if (singleSeat.Type._text === "1") {
            return "wheel disabled seat";
          }
          return "seat disabled";
        }
      }
      if (singleSeat.Type._text === "1") {
        return "wheel";
      }
      return "seat";
    },
    hidePriceModal() {
      this.$refs.gogoModal.hide();
    },
    IncrementSelected(item, index2, index1) {
      this.priceTypeArray[index1]["PriceType"][index2]["Selected"]++;
      this.priceTypeArray[index1]["NoOfSeatSelected"]++;
      this.ServiceFeeNew = parseFloat(
        +parseFloat(this.ServiceFeeNew) + parseFloat(item.ServiceFee)
      ).toFixed(2);
      this.TaxAmountNew = parseFloat(
        +parseFloat(this.TaxAmountNew) + parseFloat(item.TaxAmountPer)
      ).toFixed(2);
      this.ServiceFeePerNew = parseFloat(
        +parseFloat(this.ServiceFeePerNew) + parseFloat(item.ServiceFeePer)
      ).toFixed(2);

      this.ticketPriceNew = parseFloat(
        +parseFloat(this.ticketPriceNew) + parseFloat(item.Price)
      ).toFixed(2);
      this.TotalPriceNew = parseFloat(
        +parseFloat(this.ticketPriceNew) + parseFloat(this.ServiceFeeNew)
      ).toFixed(2);
    },
    DecrementSelected(item, index2, index1) {
      if (this.priceTypeArray[index1]["PriceType"][index2]["Selected"] > 0) {
        this.priceTypeArray[index1]["PriceType"][index2]["Selected"]--;
        this.priceTypeArray[index1]["NoOfSeatSelected"]--;
        this.ServiceFeeNew = parseFloat(
          parseFloat(this.ServiceFeeNew) - parseFloat(item.ServiceFee)
        ).toFixed(2);

        this.TaxAmountNew = parseFloat(
          parseFloat(this.TaxAmountNew) - parseFloat(item.TaxAmountPer)
        ).toFixed(2);
        this.ServiceFeePerNew = parseFloat(
          parseFloat(this.ServiceFeePerNew) - parseFloat(item.ServiceFeePer)
        ).toFixed(2);
        this.ticketPriceNew = parseFloat(
          parseFloat(this.ticketPriceNew) - parseFloat(item.Price)
        ).toFixed(2);
        this.TotalPriceNew = parseFloat(
          this.TotalPriceNew -
            parseFloat(item.Price) -
            parseFloat(item.ServiceFee)
        ).toFixed(2);
      }
    },
    totalCount(rg, index, rg_index, type) {
      let seatsSelectedRateGroupCopy = cloneDeep(
        this.seatsSelectedRateGroupNew
      );
      let x = seatsSelectedRateGroupCopy[index]["rate_card_group"][rg_index];
      if (
        type == "increment" &&
        seatsSelectedRateGroupCopy[index].totalSelected ==
          seatsSelectedRateGroupCopy[index].AllSeats.length
      ) {
        return false;
      }

      if (
        type == "increment" &&
        this.totalSeatBooked + 1 <= this.$store.getters.SELECTED_SEATS.length &&
        x["totalSeatSelected"] <= this.$store.getters.SELECTED_SEATS.length
      ) {
        x["totalSeatSelected"] = x["totalSeatSelected"] + 1;
        seatsSelectedRateGroupCopy[index].totalSelected =
          seatsSelectedRateGroupCopy[index].totalSelected + 1;
      } else if (
        seatsSelectedRateGroupCopy[index].totalSelected >= 1 &&
        type == "decrement" &&
        x["totalSeatSelected"] >= 1
      ) {
        x["totalSeatSelected"] = x["totalSeatSelected"] - 1;
        seatsSelectedRateGroupCopy[index].totalSelected =
          seatsSelectedRateGroupCopy[index].totalSelected - 1;
      }

      let totalAmount = 0;
      let totalSeatBooked2 = 0;
      let totalNetAmout2 = 0;
      seatsSelectedRateGroupCopy.map((z) => {
        z.rate_card_group.map((y) => {
          totalAmount =
            parseFloat(totalAmount) +
            parseFloat(y.totalSeatSelected) * parseFloat(y.rc_total_amount);

          totalNetAmout2 =
            parseFloat(totalNetAmout2) +
            parseFloat(y.totalSeatSelected) * parseFloat(y.rc_net_amount);
        });

        totalSeatBooked2 =
          parseInt(totalSeatBooked2) + parseInt(z.totalSelected);
      });
      this.totalAmountPrice = totalAmount;
      this.totalSeatBooked = totalSeatBooked2;
      this.totalNetAmout = totalNetAmout2;
      if (totalSeatBooked2 == this.$store.getters.SELECTED_SEATS.length) {
      } else {
        this.$store.dispatch("onSetCompleteRateCard", {
          status: false,
          seatGroup: cloneDeep(seatsSelectedRateGroupCopy),
        });
      }
      this.seatsSelectedRateGroupNew = seatsSelectedRateGroupCopy;
      if (this.totalSeatBooked == this.$store.getters.SELECTED_SEATS.length) {
        this.errorMessage = "";
      } else {
        this.errorMessage = "Please Select All Seats";
      }
    },
    onClickOk: function () {
      this.count = 0;
      this.$refs.WheelChairModal.hide();
    },
    onClickTab: function () {
      this.showCollapseSeatLayout = !this.showCollapseSeatLayout;
    },

    onEdit: function () {
      this.totalNumberOfSeats = 0;
      this.editNumberOfSeats(0);
    },
    fetchScheduleDetail: function () {
      let payload = {
        ss_id: this.ss_id,
      };
      MainServices.getScheduleDetails(payload)
        .then((response) => {
          const { error, res } = response;
          this.movieDetails = response.data.Records[0];
          this.movieDetails["mrrdr_release_date_year"] = moment(
            this.movieDetails.mrrdr_release_date
          ).format("YYYY");
        })
        .catch((error) => {
        });
    },

    getSeatLayoutList: function () {
      let payload = {
        screen_id: this.screen_id,
        ss_id: this.ss_id,
        md_id: this.MovieID,
        vista_schedule_id: this.vista_schedule_id,
      };
      MainServices.getSeatLayout(payload)
        .then((response) => {
          const { error, res } = response;
          this.seatLayout = response.data.seatLayoutNew;
        })
        .catch((error) => {
          console.log("Error", error);
        });
    },

    editNumberOfSeats: function (number) {
      this.SelectNumberOfSeats(number);
      this.totalNumberOfSeats = number;
      //deselect all
      this.selectedSeats.map((x, index) => {
        this.seatLayout[x.mainIndex].Seats[x.rowIndex][
          x.seatIndex
        ].SelectStatus = false;
        this.seatLayout[x.mainIndex].Seats[x.rowIndex][
          x.seatIndex
        ].SelectStatusFlag = false;
      });
      this.selectedSeats = [];
    },
    handlerSeatSelected: async function (
      seat,
      rowIndex,
      seatIndex,
      originalIndex,
      backward,
      e,
      type
    ) {
      if (seat.seat_reserve_type_id == 9) {
        this.$toasted.show(
          $t("Sorry! These seats can be booked from Box Office only")
        );
        return;
      }

      let payload = {
        seat,
        rowIndex,
        seatIndex,
        originalIndex,
        backward,
        e,
        type,
      };
      await this.seatHandler(payload);
      if (seat.srt_id && seat.srt_id == 3) {
        this.$refs.WheelChairModal.show();
      } else if (seat.status && seat.status == 3) {
        this.$refs.WheelChairModal.show();
      }
    },
    seatsSelectedRateGroup() {
      if (this.vista_schedule_id) {
        this.totalSeatBooked = this.$store.getters.SELECTED_SEATS.length;
        this.totalAmountPrice = 0;
        this.totalNetAmout = 0;
        const seatType = this.seatType[0];
        const seat_price = parseFloat(seatType.seat_price);
        this.$store.getters.SELECTED_SEATS.forEach((seat) => {
          this.totalAmountPrice = this.totalAmountPrice + seat_price;
          this.totalNetAmout = this.totalNetAmout + seat_price;
        });
      } else if (this.rts_performance_id) {
        this.totalSeatBooked = this.$store.getters.SELECTED_SEATS.length;
        this.totalAmountPrice = 0;
        this.totalNetAmout = 0;
        const seatType = this.seatType[0];
        const seat_price = parseFloat(seatType.seat_price);
        this.$store.getters.SELECTED_SEATS.forEach((seat) => {
          this.totalAmountPrice = this.totalAmountPrice + seat_price;
          this.totalNetAmout = this.totalNetAmout + seat_price;
        });
      } else {
        let array = [];
        if (this.checkPopupExist == false) {
          this.totalSeatBooked = 0;
          this.totalAmountPrice = 0;
          this.totalNetAmout = 0;
          let checkCheckoutRateCardNeeded = 0;
          if (this.$store.getters.SELECTED_SEATS.length > 0) {
            this.$store.getters.SELECTED_SEATS.map((x) => {
              let find_In = array.findIndex((new1) => {
                // return new1.sst_id == x.sst_id;
                return new1.sst_id == x.sst_id;
              });
              if (find_In >= 0) {
                array[find_In]["AllSeats"].push(x);
                if (array[find_In]["rate_card_group"].length == 1) {
                  array[find_In]["totalSelected"] =
                    array[find_In]["totalSelected"] + 1;
                  array[find_In]["rate_card_group"][0].totalSeatSelected =
                    array[find_In]["rate_card_group"][0].totalSeatSelected + 1;
                  this.totalAmountPrice =
                    parseFloat(this.totalAmountPrice) +
                    parseFloat(
                      array[find_In]["rate_card_group"][0].rc_total_amount
                    );
                  this.totalNetAmout =
                    parseFloat(this.totalNetAmout) +
                    parseFloat(
                      array[find_In]["rate_card_group"][0].rc_net_amount
                    );
                  this.totalSeatBooked = this.totalSeatBooked + 1;
                } else if (array[find_In]["rate_card_group"].length > 1) {
                  checkCheckoutRateCardNeeded = checkCheckoutRateCardNeeded + 1;
                }
              } else {
                let arrayCardGroup = [];
                x.rate_card_group.map((rg) => {
                  rg["totalSeatSelected"] = 0;
                  arrayCardGroup.push(rg);
                });
                let obj = {
                  srt_name: x.sst_seat_type,
                  sst_id: x.sst_id,
                  AllSeats: [x],
                  totalSelected: 0,
                  rate_card_group: arrayCardGroup,
                };
                if (arrayCardGroup.length == 1) {
                  obj["totalSelected"] = 1;
                  obj["rate_card_group"][0].totalSeatSelected = 1;
                  this.totalAmountPrice =
                    parseFloat(this.totalAmountPrice) +
                    parseFloat(obj["rate_card_group"][0].rc_total_amount);
                  this.totalNetAmout =
                    parseFloat(this.totalNetAmout) +
                    parseFloat(obj["rate_card_group"][0].rc_net_amount);
                  this.totalSeatBooked = this.totalSeatBooked + 1;
                } else if (arrayCardGroup.length > 1) {
                  checkCheckoutRateCardNeeded = checkCheckoutRateCardNeeded + 1;
                }
                array.push(obj);
              }
            });
            this.seatsSelectedRateGroupNew = array;

            if (
              checkCheckoutRateCardNeeded == 0 &&
              array[0]["rate_card_group"].length > 0
            ) {
              this.$store.dispatch("onSetCompleteRateCard", {
                status: true,
                seatGroup: cloneDeep(this.seatsSelectedRateGroupNew),
              });
              this.$store.dispatch("onSetCompleteNewTotalAmount", {
                totalAmount: this.totalAmountPrice,
                netAmount: this.totalNetAmout,
              });
            } else if (checkCheckoutRateCardNeeded > 0) {
              this.$store.dispatch("onSetCompleteRateCard", {
                status: false,
                seatGroup: cloneDeep(this.seatsSelectedRateGroupNew),
              });
            }

            return array;
          } else {
            this.seatsSelectedRateGroupNew = [];
            return array;
          }
        } else {
          return this.seatsSelectedRateGroupNew;
        }
      }
    },

    checkForWheelChair: function () {
      let popUpStatus = 0;
      let self = this;
      this.selectedSeats.map((x, index) => {
        if (x.Status == 3 && popUpStatus == 0) {
          this.$refs.WheelChairModal.show();
          popUpStatus = 1;
          self.count = 0;
        }
      });
    },
    ProceedNew: function () {
      let seatId = [];
      let seatNames = [];
      this.selectedSeats.map((x) => {
        seatId.push(parseInt(x.SeatlayoutID));
        seatNames.push(x.SeatName);
      });

      this.secureStore.set("BSN", seatNames.toString());
      this.secureStore.set("BSID", seatId.toString());
      let ShowType = this.secureStore.get("SCRT") || "";
      // let CinemaScheduleID = this.CinemaTimeScheduleID;
      //check seats available
      let payload = {
        BookSeats: seatId,
        CategoryID: this.CategoryID,
        CinemaScheduleID: this.CinemaTimeScheduleID,
        ShowType: ShowType,
        ticketPrice: this.ticketPriceNew,
        ServiceFee: this.ServiceFeePerNew,
        TaxRate: this.TaxRate,
        TaxAmount: this.TaxAmountNew,
        TotalPrice: this.TotalPriceNew,
        TotalTaxAmount: this.ServiceFeeNew,
        PriceType: this.priceTypeArray,
      };
      makeRequest("/CheckAvailable/", "POST", null, payload)
        .then((response) => {
          const { error, res } = response;
          if (res.data.Status && res.data.SeatStatus) {
            this.secureStore.set("RID", res.data.ReserveID);

            this.$router.push({
              name: "payment",
              params: {
                categoryId: this.CategoryID,
                scheduleId: this.CinemaTimeScheduleID,
              },
            });
          } else {
            this.showMessage = res.data.Message;
          }
        })
        .catch((error) => {
          this.showMessage = "Something went wrong";
        });
    },
    setBookingSeats: function () {
      if (this.totalSeatBooked == this.$store.getters.SELECTED_SEATS.length) {
        this.onSubmitFromRateCardModal();
      } else {
        // this.errorMessage = `Please Select All Seats`;
        this.$refs.showRateCard.show();
      }
    },
    onSubmitFromRateCardModal() {
      if (
        !(this.totalSeatBooked == this.$store.getters.SELECTED_SEATS.length)
      ) {
        return false;
      }

      this.$store.dispatch("onSetCompleteRateCard", {
        status: true,
        seatGroup: this.seatsSelectedRateGroupNew,
      });

      this.$store.dispatch("onSetCompleteNewTotalAmount", {
        totalAmount: this.totalAmountPrice,
        netAmount: this.totalNetAmout,
      });

      this.reserveSeats();
      this.$refs.showRateCard.hide();
    },
    async reserveSeats() {
      try {
        this.showLoading();
        let reservation_id = Math.floor(100000000 + Math.random() * 900000000);
        if (this.vista_schedule_id) {
          const seats = this.$store.getters.seatsSelected.map((ticket) => {
            return {
              areaCategoryCode: this.seatType[0].areaCategoryCode,
              areaNumber: ticket.position.areaNumber,
              columnId: ticket.position.columnIndex,
              rowId: ticket.position.rowIndex,
            };
          });

          const payload = {
            cinemaChainId: this.seatType[0].cinemaChainId,
            showtimeId: this.vista_schedule_id,
            ticketTypes: [
              {
                showtimeId: this.vista_schedule_id,
                id: this.seatType[0].ticket_type_id,
                quantity: this.$store.getters.seatsSelected.length,
              },
            ],
            seats: seats,
          };
          let dataNew = await vistaServices.reserveSeats(payload);
          const { data } = dataNew;
          if (data.status) {
            this.hideLoading();
            this.$router.push({
              path: `/v-payment/${data.data.vista_order_id}`,
            });
          } else {
            this.$refs.showRateCard.hide();
            this.showMessage = `Sorry, those seats have already been reserved. Please choose new seats.`;
            this.$refs.SeatRealeased.show();
            this.hideLoading();
          }
          return false;
        } else if (this.rts_performance_id) {
          const res = await rtsServices.reserveSeats({
            rts_performance_id: this.rts_performance_id,
            Seats: this.$store.getters.seatsSelected,
            amount: this.totalAmountPrice,
          });

          // return;

          if (res.data.status) {
            this.hideLoading();
            this.$router.push({
              path: `/rts-payment/${res.data.data.rts_reserve_id}`,
            });
          } else {
            this.getSeats({
              md_id: this.MovieID,
              screen_id: this.screen_id,
              ss_id: this.ss_id,
              vista_schedule_id: this.vista_schedule_id,
              rts_performance_id: this.rts_performance_id,
            });
            this.$refs.showRateCard.hide();
            this.showMessage = `Sorry, those seats have already been reserved. Please choose new seats.`;
            this.$refs.SeatRealeased.show();
            this.hideLoading();
            return;
          }

          return;
        } else {
          await this.$store.dispatch("RESERVE_SEATS", {
            seat_layout_id: this.$store.getters.seatsSelected,
            schedule_show_id: this.ss_id,
            reservation_id: reservation_id,
            aggregator_cinema: this.movieDetails.cine_id,
            seatGroup: this.seatsSelectedRateGroupNew,
          });
        }

        // const { ss_id } = this.$route.params;
        if (this.$store.getters.seatsSelected.length > 0) {
          this.hideLoading();
          // await this.getAdditionalCharges({
          //   movieDetails: this.schedule_details_obj,
          //   selected_seats: this.seatsSelected,
          //   showDetails: this.schedule_details_obj
          // });
          this.$router.push({
            path: `/payment/${reservation_id}/1`,
          });
        } else {
          this.$refs.showRateCard.hide();
          this.showMessage = `Sorry, those seats have already been reserved. Please choose new seats.`;
          this.$refs.SeatRealeased.show();
          this.hideLoading();
        }
      } catch (err) {
        console.log("Error in reserve seat ", err);
        this.showMessage = `Sorry, those seats have already been reserved. Please choose new seats.`;
        this.$refs.SeatRealeased.show();
        this.hideLoading();
      }
    },
    hideModal() {
      this.$refs.SeatRealeased.hide();
      this.showLoading();
      this.resetList();
      setTimeout((x) => {
        this.hideLoading();
      }, 3000);
    },
    resetList() {
      this.onResetSeatLayout();
      this.totalNumberOfSeats = 0;
      this.editNumberOfSeats(0);
      this.getSeats({
        md_id: this.MovieID,
        screen_id: this.screen_id,
        ss_id: this.ss_id,
        vista_schedule_id: this.vista_schedule_id,
        rts_performance_id: this.rts_performance_id,
      });
    },
  },
};
</script>

<style scoped>
.red-line {
  background: linear-gradient(179.82deg, #e70d00 17.86%, #fa5402 126.35%);
}

/* CALENDER */

.calendar .weekdays .day-grid {
  /* display: flex;
  justify-content: center;
  align-items: center; */
  height: 40px;
  width: 40px;
  font-size: 14px;
  color: #212b36;
}
</style>

<style>
:root {
  --primary: #e70d00;
}
.text-red {
  color: var(--red) !important;
}

.section-seat-layout {
  padding: 15px;
  min-height: 95vh;
  overflow: hidden;
  margin-top: 15px;
  margin-bottom: 50px;
  border-radius: 17.5px;
  background-color: #fff;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.seat-layout-header {
  margin-left: -15px;
  margin-right: -15px;
  padding-bottom: 15px;
}

.seat-layout-content {
  padding: 20px;
  overflow: auto;
  height: calc(100% - 250px);
  border-top: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.seat-layout-content table:not(:last-child) {
  margin-bottom: 30px;
}

.seat-type {
  color: grey;
  font-size: 12px;
  text-align: center;
  padding-bottom: 10px;
}

.seat-layout-footer {
  text-align: center;
}

.seat-information {
  display: flex;
  font-size: 12px;
  margin-top: 15px;
  margin-bottom: 15px;
  align-items: center;
  justify-content: center;
}

.seat-information .seat {
  width: 17.5px;
  height: 17.5px;
  margin-left: 0;
  border-radius: 3px;
}

.seat {
  width: 30px;
  margin: 5px;
  height: 30px;
  color: grey;
  cursor: pointer;
  font-size: 11px;
  padding-top: 6px;
  text-align: center;
  border-radius: 5px;
  border: none;
}

.seat-red {
  width: 30px;
  margin: 5px;
  height: 30px;
  color: red;
  cursor: pointer;
  font-size: 11px;
  padding-top: 6px;
  text-align: center;
  border-radius: 5px;
  border: 1px solid grey;
}

.screen-image {
  height: auto;
  max-width: 90%;
  display: table;
  margin: 0 auto;
  transform: rotate(180deg);
}

.screen-text {
  left: 50%;
  top: calc(50% - 3px);
  z-index: 1;
  color: grey;
  font-size: 10px;
  position: absolute;
  transform: translateX(-50%);
}

.seat.seat-selected {
  color: #fff;
  background-color: var(--primary);
  border-color: var(--primary);
}

.seat.seat-unavailable {
  cursor: auto;
  user-select: none;
  background-color: grey;
}

.seat.seat-block {
  cursor: auto;
  user-select: none;
  background-color: #3876d2;
}

.seat-layout-content table {
  margin: 0 auto;
}

.pos-seat-class {
  text-align: center;
}

.pos-seatNumber {
  line-height: 1;
  font-size: 12px;
  padding-bottom: 3px;
  position: relative;
  /* bottom: -5px; */
  text-align: center;
}

.your-selection {
  border-color: var(--seatSelection) !important;
}

.your-selection::after {
  left: 0;
  content: "";
  height: 6px;
  width: 100%;
  bottom: 5px;
  display: block;
  position: absolute;
  transform: rotate(0deg);
  background-color: var(--seatSelection);
}

.rate-grid-col {
  display: grid;
  grid-template-columns: 20% 75%;
  grid-column-gap: 25px;
  align-items: center;
}

.btn-submit-disabled-grey {
  background-color: var(--grey) !important;
  border: 0 !important;
}

@media (max-width: 1300px) {
  .rate-grid-col {
    display: grid;
    grid-template-columns: 100%;
    grid-column-gap: 25px;
    align-items: center;
  }
  .category {
    margin-left: auto;
    margin-right: auto;
  }
}

@media (max-width: 767px) {
  .section-seat-layout {
    height: auto;
  }
  .list-inline-item:not(:last-child) {
    margin-right: 0.3rem;
  }

  .showtime-date {
    width: 90%;
  }
  .rate-grid-col {
    display: grid;
    grid-template-columns: 100%;
    grid-column-gap: 25px;
    align-items: center;
  }
  .category {
    margin-left: auto;
    margin-right: auto;
  }
  .seat-type .st-name {
    font-size: 1.5rem;
  }
  .h-56 {
    height: 56px;
  }
}
.select-seat-container-myticket .st-name {
  background: whitesmoke;
  color: black;
  padding: 10px;
  margin-bottom: 13px;
  font-size: 18px;
}
.seat-layout-shows {
  width: 85%;
  margin: 0 auto;
}
.seat-layout-shows .slick-next {
  right: -5% !important;
}
.seat-layout-shows .slick-prev {
  left: -5% !important;
}

#seat_select_modal .modal-body {
  background: white !important;
}
.align-self-center {
  -ms-flex-item-align: center !important;
  align-self: center !important;
}
@media only screen and (min-width: 620px) {
  .btn-add-myticket,
  .btn-subtract-myticket,
  .btn-first-add-myticket {
    width: 28px;
    height: 25px;
    color: #000;
    font-size: 14px;
    font-weight: bold;
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid var(--primary);
  }
}
.btn-add-myticket.disabled,
.btn-subtract-myticket.disabled {
  background: white;
  color: black;
}
.btn-add-myticket,
.btn-subtract-myticket,
.btn-first-add-myticket {
  width: 35px;
  height: 35px;
  color: #000;
  font-size: 20px;
  font-weight: bold;
  border-radius: 8px;
  background-color: #fff;
  border: 1px solid var(--primary);
  color: #fff;
  background-color: var(--primary);
}

.btn-add-myticket:hover,
.btn-add-myticket:focus,
.btn-subtract-myticket:hover,
.btn-subtract-myticket:focus,
.btn-first-add-myticket:hover,
.btn-first-add-myticket:focus {
  outline: none;
  /* color: #fff; */
  /* background-color: var(--primary); */
}
.btn-add-myticket:hover,
.btn-add-myticket:focus,
.btn-subtract-myticket:hover,
.btn-subtract-myticket:focus,
.btn-first-add-myticket:hover,
.btn-first-add-myticket:focus {
  outline: none;
  /* color: #fff; */
  /* background-color: var(--primary); */
}

element.style {
}
.select-seat-container-myticket .st-name {
  background: whitesmoke;
  color: black;
  padding: 10px;
  margin-bottom: 13px;
  font-size: 18px;
}
*,
*::before,
*::after {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
user agent stylesheet div {
  display: block;
}
.select-seat-container-myticket {
  width: 100%;
  overflow: hidden;
  padding-top: 25px;
  text-align: center;
  border-radius: 15px;
  background-color: #fff;
  /* box-shadow: 0px 2px 12px 1px rgb(4 4 4 / 30%); */
}
.w-100px {
  width: 100px;
}
.text-primary-new {
  color: var(--primary) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/seatLayout/seatlayout.vue